import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Fade } from '@material-ui/core'

import Button from 'components/CustomButtons/Button.jsx'
import GridContainer from 'components/Grid/GridContainer'
import GridItem from 'components/Grid/GridItem'

import { germiniDefaultColors } from 'assets/jss/material-dashboard-pro-react'
import { GetThemeColorFromStorage } from '../../../../redux/api/themeColor'

import { ModalContainer, PaperContainer } from './styles'

import { ButtonClose } from 'components/NewButton/styles'
import { GetContact } from '../../../../redux/api/footer'
import { IconInfor } from '../../../../assets/icons_svg'
import { Box, Typography } from '@mui/material'

function ModalResendEmail({
    className,
    closeByClick,
    handleSendEmail,
    handleClose,
    maxWidth,
    minWidth,
    open,
    shadow,
    t,
    themeColor,
    email,
}) {
    const [contact, setContat] = useState()
    const GetContactInfo = async () => {
        const res = await GetContact()
        res && setContat(res)
    }

    useEffect(() => {
        GetContactInfo()
    }, [])

    const blankedEmail = (email) => {
        if (email) {
            let newEmail = `${email.split('', 2)}...@...${email
                .split('', -1)
                .slice(-4)}`
            return newEmail.replaceAll(',', '')
        }
    }

    return (
        <ModalContainer
            open={open}
            className={className}
            onClose={closeByClick}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            shadow={shadow}
            maxwidth={maxWidth}
            minwidth={minWidth}
            disableEnforceFocus
            style={{
                backdropFilter: 'blur(4px)',
            }}
        >
            <Fade in={open} unmountOnExit>
                <PaperContainer maxwidth={maxWidth}>
                    <Box display="flex" flexDirection="column" gap={2} p={3}>
                        <Box display="flex" justifyContent="flex-end">
                            <Box
                                component="i"
                                onClick={handleClose}
                                className="icon-ico_cancelar"
                                fontSize="20px"
                                color="#e01e36"
                                sx={{ cursor: 'pointer' }}
                            />
                        </Box>
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <IconInfor
                                sx={{
                                    pb: '16px',
                                    fontSize: '90px !important',
                                    color:
                                        themeColor?.visual?.icons?.color ||
                                        '#eea236',
                                }}
                            />
                        </Box>
                        <Box textAlign="center" gap="20px">
                            <Typography
                                variant="body2"
                                fontSize="15px"
                                fontWeight={'bold'}
                            >
                                {t('We have identified that your registration')}
                                <br />
                                {t('Resend the email to')} {blankedEmail(email)}{' '}
                                {t('and perform the validation')}
                            </Typography>
                            <Typography
                                variant="body2"
                                fontSize="13px"
                                color="#9B9B9B"
                            >
                                <p>
                                    {t(
                                        'If you have not received it, please check your junk',
                                    )}
                                </p>
                                <p
                                    style={{
                                        margin: '10px 0',
                                        color: themeColor?.navigation?.buttons
                                            ?.backgroundColor,
                                    }}
                                >
                                    E-mail: {contact?.contactEmail || ''}
                                </p>
                                <p
                                    style={{
                                        marginTop: '0px',
                                        color: themeColor?.navigation?.buttons
                                            ?.backgroundColor,
                                    }}
                                >
                                    {t('FIELD_REGISTER_PHONE')}:{' '}
                                    {contact?.contactPhoneNumber || ''}
                                </p>
                            </Typography>
                        </Box>
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Button
                                size="sm"
                                variant="contained"
                                color={'greenButtonColor'}
                                defaultTheme={themeColor}
                                onClick={handleSendEmail}
                            >
                                {t('Resend email')}
                            </Button>
                        </Box>
                    </Box>
                </PaperContainer>
            </Fade>
        </ModalContainer>
    )
}

ModalResendEmail.propTypes = {
    children: PropTypes.element,
    className: PropTypes.string,
    closeByClick: PropTypes.func,
    handleClose: PropTypes.func,
    handleSendEmail: PropTypes.func,
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    open: PropTypes.bool,
    padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    shadow: PropTypes.string,
}

ModalResendEmail.defaultProps = {
    children: null,
    className: '',
    closeByClick: null,
    handleClose: null,
    handleSendEmail: null,
    maxWidth: '',
    minWidth: '',
    open: false,
    padding: '',
    shadow: '',
}

export default withTranslation()(ModalResendEmail)
